module.exports = __webpack_public_path__ + "img/Sherry.c10c2a4c.png";